import { render, staticRenderFns } from "./ObservationsCounterBadge.vue?vue&type=template&id=c9208ff0&"
import script from "./ObservationsCounterBadge.vue?vue&type=script&lang=js&"
export * from "./ObservationsCounterBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports